<script setup lang="ts">
import { computed } from 'vue'

import { StatusType } from '@collector/sportsapi-client-legacy'
import { useEvent } from '@desktop/views/Relation/composables'
import { usePitchIncidentsBlockades } from '@desktop/views/Relation/Sports/composables'
import { injectPitchIncidentsConfig } from '@desktop/views/Relation/Sports/provide-inject'

interface Props {
  withText?: boolean
}

defineProps<Props>()

// inject
const { eventStatusToBlockedPitchIncidentsTextMap } =
  injectPitchIncidentsConfig()

// composables
const { isEveryPitchIncidentBlocked } = usePitchIncidentsBlockades()
const { event } = useEvent()

// computed
const eventStatusId = computed(() => event.value.status_id)
const hasEventStatusFinished = computed(
  () => event.value.status_type === StatusType.Finished,
)
const blockedIncidentsText = computed(() =>
  eventStatusToBlockedPitchIncidentsTextMap?.get(eventStatusId.value),
)
</script>

<template>
  <div
    v-if="isEveryPitchIncidentBlocked"
    class="bg-neutral-light-10/70 absolute z-10 h-full w-full select-none"
    :class="{
      'flex flex-col items-center justify-center text-sm font-bold': withText,
    }"
    data-testid="pitch-blocked-incident-overlay"
  >
    <template v-if="withText">
      <div
        v-if="blockedIncidentsText"
        class="flex flex-col items-center"
      >
        <div class="text-center">To unblock the Incidents panel,</div>
        <div class="text-center">{{ blockedIncidentsText }}</div>
      </div>
      <div v-else-if="hasEventStatusFinished">Match finished</div>
      <div v-else>
        {{ event.status_name }}
      </div>
    </template>
  </div>
</template>
